export default __webpack_public_path__ + "static/media/music-ranker-logo.82fc1a4d.svg";